<template>
  <div
    class="bp-marks"
    aria-hidden="true"
  >
    <div class="bp-marks__layer">
      <span class="bp-marks__cross" />
      <span class="bp-marks__coord">{{ coord }}</span>
      <span class="bp-marks__rule" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ coord: string }>()
</script>
